/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import GlobalLayout from './src/layouts/global';
import './src/styles/global.css';
import RootWrapper from './src/wrappers/root';
import { navigate } from 'gatsby';
import { useAuthStore } from './src/common/hooks/useAuthStore';
import { REGION_MAP, getRegionUriFromRegionMap } from './src/utils/regionUtils';

export const wrapPageElement = ({ element, props }) => {
  const authStore = useAuthStore();
  const currentUrl = window.location.href.split('/');
  if (currentUrl?.includes('500')) {
    return <RootWrapper {...props}>{element}</RootWrapper>;
  }
  let regionFromUrl = REGION_MAP[currentUrl[3]?.toUpperCase()]; // NCAL | SCAL
  const userRegion = authStore?.userProfile?.region?.toUpperCase(); //SCAL
  if (authStore.userProfile && userRegion !== regionFromUrl) {
    currentUrl[3] = getRegionUriFromRegionMap(userRegion);
    const url = currentUrl.join('/');
    navigate(url);
  }
  return <GlobalLayout {...props}>{element}</GlobalLayout>;
};

export const wrapRootElement = ({ element }) => {
  return <RootWrapper>{element}</RootWrapper>;
};
